import { useCallback } from 'react';
import { useCampaignEditorContext } from '../hooks/useCampaignEditorContext';

export const useSetSortOption = () => {
  const { dispatch } = useCampaignEditorContext();

  return useCallback(
    (sortByFeature: boolean) => {
      dispatch({ type: 'SET_SORT_OPTION', payload: sortByFeature });
    },
    [dispatch],
  );
};
